import { API, graphqlOperation } from 'aws-amplify'
import { listUsers } from '@/graphql/queries.js'

const MAX_ITEMS=100;

// Vuex state
const state = {
    all: []
}

// Vuex getters
const getters = {
}

async function loadUsers() {
    let users = []
    var nextToken, items
    do {
        ({ data: { listUsers: { items, nextToken } } } = await API.graphql(graphqlOperation(listUsers, {
            limit: MAX_ITEMS,
            nextToken
        })))
        users.push(...items)
    } while (nextToken)
    return users
}
// Vuex actions
const actions = {
    async load({ commit }/*, username*/) {
        try {
            let users = await loadUsers()

            console.log("users", users)
            commit('setUsers', users)
        }
        catch (err) {
            console.log('error listing users: ', err)
        }
    },
}

// Vuex mutations
const mutations = {
    setUsers(state, users) {
        state.all = users
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
